import React from 'react';

import Button from '@atlaskit/button/new';

const ButtonFullWidthExample = (): React.JSX.Element => {
	return (
		<Button shouldFitContainer appearance="primary">
			Full width button
		</Button>
	);
};

export default ButtonFullWidthExample;
